/* eslint-disable */

import { useMemo, useEffect, useState, useCallback } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
// import TrackChangesIcon from '@mui/icons-material/TrackChanges' // Commented out - Goal Planning not using now
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { get } from '../../http/restservice'
import { useLocation, useNavigate } from 'react-router-dom'
import env from '../../env/env'
import PlansCarousel from '../../Components/Home/PlansCarousel'
import useMediaQuery from '../../hooks/useMediaQuery'
import { getUserDetails } from '../../utils/AuthUtil'

//SVGS to upload
import insurance from '../../assets/newHome/insurance.svg'
import taxPlanning from '../../assets/newHome/taxPlanning.svg'

import { useRecoilState, useRecoilValueLoadable } from 'recoil'
import { isDematUser } from '../../utils/AuthUtil'
import { Skeleton } from '../../Components/ui/skeleton'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { HomeCarouselCards } from '../../store/HomePageStore'
import IntroVideo from '../FirstIdeas/IntroVideo'
import { UserKycStatus } from '../../store/UserStore'
import { userDetailsState } from '../LoginState'
import { MFUserBaskets } from '../../store/MFBasketsStore'
import { messageModalState } from '../../store/Feedback'
import { useSetRecoilState } from 'recoil'
import { Badge } from '../../Components/ui/badge'
import { StoriesFeed } from '../../Components/StoriesFeed/StoriesFeed'

// Animation variants
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.25,
      ease: 'easeOut',
    },
  },
  hover: {
    scale: 1.02,
    y: -4,
    transition: {
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
  tap: {
    scale: 0.98,
    transition: {
      duration: 0.1,
    },
  },
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.05,
    },
  },
}

const Card = ({ title, desc, gradient, icon: Icon, onClick, topCard, bottomCard }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [isHovered, setIsHovered] = useState(false)

  return (
    <motion.div
      className={`h-full`}
      variants={cardVariants}
      initial='hidden'
      animate='visible'
      whileHover='hover'
      whileTap='tap'
      style={{
        border: gradient ? '1px solid transparent' : '',
        borderRadius: '16px',
        background: gradient
          ? 'linear-gradient(white, white) padding-box, linear-gradient(93.32deg, rgba(31, 160, 230, 0.8) 0%, rgba(236, 41, 197, 0.8) 49.96%, rgba(236, 127, 38, 0.8) 99.91%) border-box'
          : '#F4F7FE',
        outline: `${isHovered && !gradient ? '1px solid #D3DBEC' : 'none'}`,
      }}
    >
      <div
        className={`flex-1 p-4 cursor-pointer h-full ${gradient && 'lg:flex lg:flex-col lg:items-center lg:justify-center'
          }`}
        style={{
          background: gradient
            ? 'linear-gradient(92.56deg, rgba(31, 160, 230, 0.08) 3.63%, rgba(236, 41, 197, 0.08) 47.06%, rgba(236, 127, 38, 0.08) 90.49%), #FFFFFF'
            : '#F4F7FE',
          borderRadius: '16px',
        }}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <motion.div
          className='flex justify-between'
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1, duration: 0.2 }}
        >
          <h1
            className={`text-lg font-medium flex items-center gap-x-2 ${gradient &&
              'pb-2 bg-gradient-to-r from-purple-500 via-pink-500 to-pink-400 bg-clip-text text-transparent lg:font-medium lg:justify-center lg:text-[32px]'
              } ${topCard && !gradient && 'lg:text-2xl'} ${bottomCard && '!text-base lg:!text-xl'}`}
          >
            {Icon && (
              <motion.div
                initial={{ rotate: -180, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                transition={{ delay: 0.15, duration: 0.25 }}
              >
                <Icon className='h-6 w-6' />
              </motion.div>
            )}
            {title}
          </h1>
          {isDesktop && !gradient && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.2 }}
            >
              <ChevronRightIcon sx={{ color: '#9E9E9E' }} />
            </motion.div>
          )}
        </motion.div>
        {desc && (
          <motion.p
            className={`text-sm mt-2 font-normal ${gradient
              ? 'bg-gradient-to-r from-blue-400 via-pink-400 to-pink-300 bg-clip-text text-transparent'
              : 'text-black-400 '
              } ${topCard ? 'lg:mt-4' : 'lg:mt-3'}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.25 }}
          >
            {desc}
          </motion.p>
        )}
      </div>
    </motion.div>
  )
}

// const userElogData = {
//   id: '7097748b-db05-43af-b2e7-52ae0ed0928b',
//   phoneNumber: '+919784102014',
//   transactionId: 'e6012564-d4f8-4eb1-b1aa-1d111222f533',
//   clientCode: 'FAB12521',
//   uccRequest: {
//     clientDob: '13/10/1997',
//     clientCity: 'PRATAPPURA',
//     clientCode: 'FAB12521',
//     incomeSlab: '5-10 LAC',
//     occupation: 'PRIVATE SECTOR SERVICE',
//     clientEmail: 'SHANTILALPATLIYA18@GMAIL.COM',
//     clientState: 'Rajasthan',
//     nominee1Dob: '15/08/1976',
//     nominee2Dob: '',
//     nominee3Dob: '',
//     clientGender: 'M',
//     nominee1City: 'PRATAPPURA',
//     nominee1Name: 'bechara ram',
//     nominee2City: 'PRATAPPURA',
//     nominee2Name: '',
//     nominee3City: 'PRATAPPURA',
//     nominee3Name: '',
//     clientCountry: 'India',
//     clientPinCode: '343041',
//     nominee1Email: 'shantilal@fabits.com',
//     nominee1IdNum: 'APKPR5891R',
//     nominee2Email: '',
//     nominee2IdNum: '',
//     nominee3Email: '',
//     nominee3IdNum: '',
//     clientAddress1: 'S/O BECHARA RAM BIROL PRATAPPURA',
//     clientAddress2: '',
//     clientAddress3: '',
//     clientFullName: 'SHANTI LAL',
//     clientIfscCode: 'SBIN0031184',
//     clientLastName: 'LAL',
//     nominee1IdType: 'pan',
//     nominee1Mobile: '8209084453',
//     nominee2IdType: '',
//     nominee2Mobile: '',
//     nominee3IdType: '',
//     nominee3Mobile: '',
//     applicationType: 'Individual',
//     clientFirstName: 'SHANTI',
//     clientPanNumber: 'AOAPL0027L',
//     nominee1Country: 'India',
//     nominee1PinCode: '343041',
//     nominee2Country: 'India',
//     nominee2PinCode: '343041',
//     nominee3Country: 'India',
//     nominee3PinCode: '343041',
//     clientMiddleName: '',
//     nominee1Address1: '',
//     nominee1Address2: '',
//     nominee1Address3: '',
//     nominee1UnderAge: 'no',
//     nominee2Address1: '',
//     nominee2Address2: '',
//     nominee2Address3: '',
//     nominee2UnderAge: 'no',
//     nominee3Address1: '',
//     nominee3Address2: '',
//     nominee3Address3: '',
//     nominee3UnderAge: 'no',
//     clientPhoneNumber: '9784102014',
//     nominee1Percentage: '100',
//     nominee2Percentage: '',
//     nominee3Percentage: '',
//     nominee1GuardianName: '',
//     nominee1Relationship: 'father',
//     nominee2GuardianName: '',
//     nominee2Relationship: '',
//     nominee3GuardianName: '',
//     nominee3Relationship: '',
//     nominee1GuardianIdNum: '',
//     nominee2GuardianIdNum: '',
//     nominee3GuardianIdNum: '',
//     clientBankAccountNumber: '61139529023',
//   },
//   kycStatus: 'SUCCESS',
//   createdTimestamp: '2025-09-23 15:13:19.417',
//   updatedTimestamp: '2025-09-23 15:16:19.708',
//   fatcaRegistered: false,
//   uccRegistered: true,
//   bankDetailsCreated: true,
//   clientCodeUpdated: true,
//   elogDone: true,
// }

const NonKycUserHomePage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [userDetails] = useRecoilState(userDetailsState)

  const actionPlans = useRecoilValueLoadable(MFUserBaskets)
  const [isFICompleted, setIsFICompleted] = useState(false)
  const kycStatus = useRecoilValueLoadable(UserKycStatus)
  const carouselCards = useRecoilValueLoadable(HomeCarouselCards)
  const [showVideo, setShowVideo] = useState(location?.state?.hasSeenVideo)
  const [showDialog, setShowDialog] = useState(true)
  const [elogStatuses, setElogStatuses] = useState({})
  const [callKycAPIs, setCallKycAPIs] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const [adminPlans, setAdminPlans] = useState([])
  const [showStoriesFeed, setShowStoriesFeed] = useState(false)

  let isUserFirstTime =
    location?.state?.firstTimeUser == true || location?.state?.hasSeenVideo === false

  useEffect(() => {
    const hasSeenVideo = localStorage.getItem('hasSeenVideo')

    if (!hasSeenVideo) {
      setShowVideo(true)
    }
  }, [])

  useEffect(() => {
    if (actionPlans?.state === 'hasValue' && Array.isArray(actionPlans?.contents?.data)) {
      const adminCuratedPlans = actionPlans?.contents?.data?.filter(
        (plan) =>
          plan.createdSource === 'ACTION PLAN' &&
          (plan?.sipStatus === 'PENDING' || plan?.oneTimeStatus === 'PENDING'),
      )

      setAdminPlans(adminCuratedPlans)
    }
  }, [actionPlans?.state, actionPlans?.contents?.data])

  useEffect(() => {
    const fetchKycNumber = async () => {
      // console.log(userDetails?.phoneNumber, 'userDetails?.phoneNumber')
      if (!userDetails?.phoneNumber) return

      // try {
      const kycNumber = await fetchCustomerKycDetails(userDetails?.phoneNumber)

      // console.log(kycNumber, 'kycNumber')

      // if (kycNumber) {
      let elgStatus = await fetchCustomerKycStatuses(userDetails?.phoneNumber)
      console.log(elgStatus, 'elgStatus')
      if (elgStatus) {
        setElogStatuses(elgStatus)
      }
      // }
      // } catch (error) {
      //   console.error('Error fetching KYC details:', error)
      // }
    }

    fetchKycNumber()
  }, [userDetails])

  useEffect(() => {
    const initializeUserDetails = () => {
      if (userDetails?.phoneNumber) {
        isQuestionaireCompleted(userDetails?.phoneNumber)
      } else {
        isQuestionaireCompleted(getUserDetails()?.phoneNumber)
      }
    }

    initializeUserDetails()
  }, [])

  const isQuestionaireCompleted = useCallback(
    async (phoneNumber) => {
      const url = `${env.API_URL}customerservice/api/firstIdeas`

      try {
        const response = await get(url, {}, { phoneNumber })
        // console.log(response)
        setIsFICompleted(response?.isCompleted)
      } catch (error) {
        console.log(error)
      }
    },
    [userDetails?.phoneNumber],
  )

  const fetchCustomerKycDetails = async (phNum) => {
    const phNo = '%2b91' + phNum?.replace(/^(\+91\s?)/, '')
    const response = await get(`${env.API_URL}customerservice/api/customer?phoneNumber=${phNo}`)

    console.log(response, 'response')
    if (!response || response?.isError) {
      return null
    }

    if (!response?.isError && response) {
      const kycPhone = response?.kycPhoneNumber
      return kycPhone
    }
  }

  const fetchCustomerKycStatuses = async (phNum) => {
    const phNo = phNum?.replace(/^(\+91\s?)/, '')

    const response = await get(
      `${env.API_URL}customerservice/api/customer/fetchCustomerKycStatuses?kycPhoneNumber=${phNo}`,
    )

    console.log(response, 'response')

    if (response?.isError) {
      return null
    }

    if (!response?.isError) {
      return response
    }
  }

  const handleVideoEnd = () => {
    localStorage.setItem('hasSeenVideo', 'true')
    setShowVideo(false)
    setShowDialog(false)
  }

  // Static cards that don't change (excluding performance card which is now in top row)
  const staticCards = [
    // {
    //   id: 5,
    //   title: (
    //     <div className='block gap-x-[10px] items-center'>
    //       <TrackChangesIcon sx={{ height: '32px', width: '32px' }} />
    //       <p>Goal Planning</p>
    //     </div>
    //   ),
    //   desc: 'Start saving for lifes bigger financial responsibilities',
    // },
    {
      id: 6,
      title: (
        <div className='flex m-2 gap-x-[10px] items-center'>
          <img src={insurance || '/placeholder.svg'} height={32} width={32} alt='Insurance' />
          <p>Insurance</p>
        </div>
      ),
      desc: 'Identify coverage gaps with policy reviews',
    },
    {
      id: 7,
      title: (
        <div className='flex m-2 gap-x-[10px] items-center'>
          <img src={taxPlanning || '/placeholder.svg'} height={32} width={32} alt='Tax Planning' />
          <p>Tax Planning</p>
        </div>
      ),
      desc: 'Personalised tax planning to maximise deductions and savings',
    },
  ]

  // Performance card (moved to top row)
  const performanceCard = {
    id: 4,
    title: (
      <div className='flex m-2 gap-x-[10px] items-center'>
        <img
          src={`${env.S3_BASE_URL}/firstTime/analytics.svg`}
          height={32}
          width={32}
          alt='Analytics'
        />
        <p className='flex items-center gap-2'>
          2025 Performance
          <Badge variant='outline' className="lg:hidden">NEW</Badge>
        </p>
      </div>
    ),
    desc: 'Fabits has outperformed its benchmarks with lower volatility',
  }


  // Dynamic action center card
  const getActionCenterCard = () => {
    if (
      actionPlans?.state === 'hasValue' &&
      actionPlans?.contents?.data?.length > 0 &&
      isFICompleted
    ) {
      return {
        id: 3,
        title: !adminPlans?.length ? 'You are all set' : 'Action Center',
        desc: !adminPlans?.length
          ? 'We will get in touch with you soon'
          : 'Proceed with your plans',
      }
    }

    if (elogStatuses?.uccRegistered && !elogStatuses?.elogDone) {
      return {
        id: 1,
        title: 'You’re almost there! 🚀',
        desc: 'Just one final step to activate your account and continue investing.',
      }
    }

    if (isFICompleted && !actionPlans?.contents?.data?.length) {
      return {
        id: 1,
        title: 'Curating your plans...',
        desc: 'We will get in touch with you soon',
      }
    }

    return {
      id: 1,
      title: 'Start here',
      desc: 'Discover your perfect fund in a few taps',
    }
  }

  // Top cards with Action Center (3/4) and Performance (1/4) in same row
  const getTopCards = () => {
    const actionCenterCard = getActionCenterCard()
    return [actionCenterCard, performanceCard]
  }

  const topCards = getTopCards()

  const topCardsDesktop = useMemo(() => topCards, [topCards])

  const bottomCards = useMemo(() => staticCards, [])
  const bottomCardsDesktop = useMemo(() => staticCards, [])

  const redirect = (id, title) => {
    // console.log(id, 'id')
    switch (id) {
      case 1: // Action Center Card
        if (elogStatuses?.uccRegistered && !elogStatuses?.elogDone) {
          navigate('/dashboard/start-kyc', {
            state: { isElogDone: false },
          })
        } else {
          if (isFICompleted) {
            navigate('/dashboard')
          } else {
            navigate('/dashboard/firstTime/questionnaire')
          }
        }
        break
      case 3:
        navigate('/dashboard/firstTime/actionPlanUser')
        break
      case 4: // 2025 Performance
        setShowStoriesFeed(true)
        break
      // case 5: // Goal Planning - commented out, not using now
      //   navigate('/dashboard/plans')
      //   break
      case 6: // Insurance
        navigate('/dashboard/insurance')
        break
      case 7: // Tax Planning
        navigate('/dashboard/tax-filing')
        break
      default:
        break
    }
  }

  return (
    <>
      {showStoriesFeed && (
        <StoriesFeed
          autoOpen={true}
          onClose={() => setShowStoriesFeed(false)}
        />
      )}

      <motion.div
        className='bg-white h-full px-4 lg:px-0 py-4 flex flex-col gap-4 lg:mx-auto lg:max-w-[1128px]'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        <AnimatePresence>
          {!isDematUser() && (
            <motion.div
              className='mb-5'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1, duration: 0.3 }}
              exit={{ opacity: 0, x: -20 }}
            >
              {!elogStatuses?.uccRegistered && !elogStatuses?.elogDone && <motion.h1
                className='font-OrelegaOne font-normal text-2xl'
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.25 }}
              >
                Complete your KYC to begin investing
              </motion.h1>}

              {!elogStatuses?.uccRegistered && !elogStatuses?.elogDone && <motion.p
                className='font-DMSans font-normal text-base text-primary-600 mt-3 flex items-center gap-2 cursor-pointer'
                onClick={() => navigate('/dashboard/start-kyc')}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.25 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}

              >
                Complete KYC details <ArrowOutwardIcon className='h-6 w-6' />
              </motion.p>}

              {kycStatus?.state === 'hasValue' &&
                kycStatus?.contents &&
                kycStatus?.contents?.status === 'success' &&
                kycStatus?.contents?.applicationStatus === 'needs_review' && (
                  <motion.p
                    className='font-DMSans font-normal text-base text-primary-600 mt-3 flex items-center gap-2 cursor-pointer'
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.25 }}
                  >
                    KYC under review
                  </motion.p>
                )}
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
          className={`flex flex-col lg:flex-row gap-4 lg:max-w-[1128px]`}
          variants={containerVariants}
          initial='hidden'
          animate='visible'
        >
          <div className={`flex-1 flex md:flex-row flex-col gap-4`}>
            <AnimatePresence>
              {(isDesktop ? topCardsDesktop : topCards).map((card, index) => (
                <motion.div
                  className={`${index === 0 ? 'flex-[2]' : 'flex-[1]'} lg:h-[150px]`}
                  key={card.id}
                  variants={cardVariants}
                  layout
                >
                  <Card
                    topCard={index === 0}
                    gradient={index === 0}
                    {...card}
                    onClick={() => redirect(card.id, card.title)}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </motion.div>

        <motion.div
          className='lg:flex gap-4 lg:max-w-[1128px]'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
        >
          {!isDesktop && (
            <>
              {/* Insurance and Tax Planning in a 2x2 grid */}
              <motion.div
                className='grid grid-cols-2 gap-4'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.25 }}
              >
                {bottomCards
                  .filter((card) => card.id === 6 || card.id === 7)
                  .map((card, index) => (
                    <motion.div
                      key={card.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.6 + index * 0.05, duration: 0.25 }}
                    >
                      <Card bottomCard {...card} onClick={() => redirect(card.id)} />
                    </motion.div>
                  ))}
              </motion.div>
            </>
          )}

          {/* Desktop view: all cards in a single row */}
          {isDesktop && (
            <>
              {bottomCardsDesktop.map((card, index) => (
                <motion.div
                  className='flex-1 h-full'
                  key={card.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 + index * 0.05, duration: 0.25 }}
                >
                  <Card bottomCard key={card.id} {...card} onClick={() => redirect(card.id)} />
                </motion.div>
              ))}
            </>
          )}
        </motion.div>

        <AnimatePresence mode='wait'>
          {carouselCards.state === 'hasValue' && carouselCards.state !== 'hasError' ? (
            <motion.div
              className='lg:max-w-[1128px] mt-10'
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.3 }}
              exit={{ opacity: 0, y: -30 }}
            >
              <motion.h1
                className='font-semibold text-lg'
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                Understand your Money
              </motion.h1>

              <motion.div
                className='flex flex-col gap-y-5 mt-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.0, duration: 0.25 }}
              >
                <PlansCarousel newPage contentCarouselData={carouselCards.contents} />
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              className='mb-6'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.25 }}
              exit={{ opacity: 0 }}
            >
              {/* Understand your money section */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                <Skeleton className='h-8 w-30 lg:w-64 mb-6' />
                <div className='flex gap-x-6 justify-between overflow-x-hidden'>
                  <Skeleton className='h-48 w-full rounded-xl' />
                  <Skeleton className='hidden md:block h-48 w-full rounded-xl' />
                  <Skeleton className='hidden lg:block h-48 w-full rounded-xl' />
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      <AnimatePresence>
        {isUserFirstTime && showVideo && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <IntroVideo
              showDialog={showDialog}
              setShowDialog={setShowDialog}
              handleVideoEnd={handleVideoEnd}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default NonKycUserHomePage
